import React, { useState } from 'react';

import { ActionPanelCard } from '@eika/action-panel-card';
import { LinkButton } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { ConfirmationDialog } from '@eika/confirmation-dialog';
import { IconTypes } from '@eika/icon';

import { useUnblockEfakturaCreditor } from '../../../fetchHooks/useEfaktura';
import type { EFakturaCreditor } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { ErrorCardWrapper } from '../../shared/ErrorCardWrapper';

import './EFakturaReservationItem.scss';

interface Props {
    creditor: EFakturaCreditor;
}

const EFakturaReservationItem: React.FC<Props> = ({ creditor }) => {
    const translated = useTranslation();
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

    const { error, isPending, isSuccess, mutate: unblockEfakturaCreditor } = useUnblockEfakturaCreditor();

    const unblockCreditor = () => unblockEfakturaCreditor(creditor.creditorId);

    if (error) {
        return (
            <ErrorCardWrapper
                title={translated.errors.oops}
                exception={error}
                defaultError={translated.eFakturaReservation.unblockError}
                className="efaktura-reservation-item--error"
            >
                <ButtonWithSpinner
                    showSpinner={isPending}
                    buttonType="positive"
                    onClick={unblockCreditor}
                    showSuccess={isSuccess}
                >
                    {translated.tryAgain}
                </ButtonWithSpinner>
            </ErrorCardWrapper>
        );
    }

    if (showConfirmationDialog) {
        return (
            <ConfirmationDialog
                title={translated.eFakturaReservation.confirmUnblock}
                id={`confirm-unblock-${creditor.creditorId.value}`}
                footer={
                    <div>
                        <LinkButton onClick={() => setShowConfirmationDialog(false)}>{translated.cancel}</LinkButton>
                        <ButtonWithSpinner
                            buttonType="positive"
                            showSpinner={isPending}
                            showSuccess={isSuccess}
                            onClick={unblockCreditor}
                        >
                            {translated.delete}
                        </ButtonWithSpinner>
                    </div>
                }
                show={showConfirmationDialog}
                onExitFocus={() => setShowConfirmationDialog(false)}
                blueBackground
                className="efaktura-reservation-item--confirmation-dialog"
            />
        );
    }

    return (
        <ActionPanelCard
            title={creditor.name}
            icon={IconTypes.SLETT_24}
            onClick={() => setTimeout(() => setShowConfirmationDialog(true), 1)}
        />
    );
};

export default EFakturaReservationItem;
